export default __webpack_public_path__ + "static/media/dribble.c2698875.svg";